import styled from 'styled-components';

export const MediaWrapper = styled.div`
  display: flex;
`;

export const LegacyMediaVideo = styled.video`
  max-height: 200px !important;
  max-width: 400px !important;
  border-radius: 8px !important;
`;

export const LegacyMediaImage = styled.img`
  max-height: 200px !important;
  max-width: 400px !important;
  border-radius: 8px !important;
`;

export const RemoveMedia = styled.button`
  display: flex;
  transition: opacity 0.3s ease-in-out;
  opacity: 0.7;
  background-image: url(/assets/images/theme-2/icons/white-trash.svg);
  background-color: ${({ theme }) => theme.colors.black_5};
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 5px;
  position: absolute;
  outline: none;
  border: none;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }
`;
